/*-----------------------------------------------------------------
- Specs rogue
-----------------------------------------------------------------*/
export default {
    sp: '،',
};
